import {Component, Input, ViewChild} from '@angular/core';
import {ExgDataListComponent} from 'exc-controls-v2';
import {ExgTabV2ComponentHeaderElement} from '../../misc/exg-tab-v2/exg-tab-v2.component';
import {ExcSecurityService} from 'exc-security-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';
import {ExcTranslation} from 'exc-core-v2';
import {ExgFilterComponent} from '../../misc/exg-filter/exg-filter.component';

@Component({
  selector: 'app-home-list-ablaufplan',
  templateUrl: './home-list-ablaufplanpunkte.component.html',
})
export class HomeListAblaufplanpunkteComponent extends ExcTranslation {
  @ViewChild('VCAblaufplanItemList', {read: ExgDataListComponent}) VCAblaufplanItemList!: ExgDataListComponent;
  @ViewChild('VCAblaufplanListFilterControl', {read: ExgFilterComponent}) VCAblaufplanListFilterControl!: ExgFilterComponent;
  @ViewChild('VCAblaufplanListSortControl', {read: ExgFilterComponent}) VCAblaufplanListSortControl!: ExgFilterComponent;
  @ViewChild('VCAblaufplanListSearchControl', {read: ExgFilterComponent}) VCAblaufplanListSearchControl!: ExgFilterComponent;

  @Input()
  homeSummaryData: any;
  rightTabs: ExgTabV2ComponentHeaderElement[] = [];

  expandedCommentApiID: string | number | null = null;

  constructor(
    public excSec: ExcSecurityService,
    public enumSvc: EnumerationService,
    private appSrv: ApplicationService) {
    super();
  }

  optimizeDateTimeFormat(dateTimeVal: any): any {
    if (dateTimeVal) {
      const date: Date = new Date(dateTimeVal);
      const offset = date.getTimezoneOffset() / 60;

      const offsetSign = offset < 0 ? '+' : '-';
      const offsetHours = ('0' + Math.abs(offset)).slice(-2);

      dateTimeVal = date.toISOString().slice(0, -1) + offsetSign + offsetHours + ':00';
      return dateTimeVal;
    }
  }

  onDblClickTaskCheckView(taskIndex: any): void {
    if (this.excSec.isFeatured('TASKREAD')) {
      this.appSrv.Task.Workspace.OpenTabV2(
        this.homeSummaryData.ablaufplan.items[taskIndex].vorgID
      );
    }
  }

  onClickOpenTaskCheckview(vorgID: any): void {
    if (this.excSec.isFeatured('TASKREAD')) {
      this.appSrv.Task.Workspace.OpenTabV2(vorgID);
    }
  }

  loadHomeSummary(): void {
    //
  }

}
